import { apiClient } from "../../api-services/axios";
import { routes } from "./routes";

export const reRoute = (payload) => {
    return apiClient({
        method: routes.RE_ROUTE.METHOD,
        url: routes.RE_ROUTE.URL,
        data: payload,
    });
};

export const deleteNumber = (payload) => {
    return apiClient({
        method: routes.DELETE_NUMBER.METHOD,
        url: routes.DELETE_NUMBER.URL,
        data: payload,
    });
};
export const addReRoute = (payload) => {
    return apiClient({
        method: routes.ADD_RE_ROUTE.METHOD,
        url: routes.ADD_RE_ROUTE.URL,
        data: payload,
    });
};
